import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { Avatar } from '#src/components/user/Avatar/index.tsx';
import { MyClubLink } from '#src/components/user/MyClubLink/index.tsx';
import { UserName } from '#src/components/user/UserName/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIntlContext } from '#src/contexts/intl/index.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'My Referrer',
  },
});

const Root = styled(Horizontal)`
  color: var(--c-nd-600);
`;

export const MyReferrer = () => {
  const { formatDate } = useIntlContext();
  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;
  const { referrer } = currentUser;
  if (!referrer) return null;

  return (
    <SettingsSection title={messages.title}>
      <Root>
        <Avatar user={referrer} size={5} />
        <div>
          <BodyM>{formatDate(referrer.createdAt)}</BodyM>
          <MyClubLink user={referrer}>
            <BodyM>
              <UserName user={referrer} />
            </BodyM>
          </MyClubLink>
        </div>
      </Root>
    </SettingsSection>
  );
};
